function Contact() {
  return (
    <div id="contact" className="homefooter">
      <div className="Getintouchidarea" id="Getintouchidarea">
        <div className="footercontainer">
          <div className="Getintouchtts">
            <h2 className="typtitle">
              Need our Services? <br /> Drop us a mail
            </h2>
            <a href="!#">24/7cybercafe@gmail.com</a>
          </div>
          <div className="Getintoucharea">
            <div className="Getintouchdetail">
              <div className="giveusarea">
                <ul>
                  <li>
                    <div className="footerdetail">
                      <p>
                        <b>Kenya</b>
                        24/7 Cybercafe
                        <br />
                        Nairobi/Kiambu county <br />
                        Kasarani sportsview junction
                      </p>
                      <a href="!#">
                        <i className="fa fa-phone" aria-hidden="true">
                          {" "}
                          0724 797790
                        </i>
                      </a>
                      <br />
                      <a href="mailto:jameskahoro07@gmail.com">
                        <i className="fa fa-envelope-o" aria-hidden="true">
                          {" "}
                          24/7cybercafe@gmail.com
                        </i>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="Getintouchbox">
              <div className="Getbtn">
                <a href="mailto:jameskahoro07@gmail.com" id="gettouch">
                  Get in touch
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
